import { useEffect, useState } from 'react'
import { useContract, useProvider } from 'wagmi'
import ERC20ABI from '../abis/erc20'

export const useTokenInfo = (tokenAddress: string) => {
  const provider = useProvider()
  const [tokenInfo, setTokenInfo] = useState({
    symbol: '',
    decimals: '',
    address: '',
  })
  const contract = useContract({
    address: tokenAddress,
    abi: ERC20ABI,
    signerOrProvider: provider,
  })

  useEffect(() => {
    ;(async () => {
      if (contract) {
        const { address } = contract
        const symbol = await contract.symbol()
        const decimals = await contract.decimals()
        setTokenInfo({ symbol, decimals, address })
      }
    })()
  }, [contract])

  return { tokenInfo, contract }
}
